import { create } from 'zustand'

export const useStore = create((set) => ({
  user: null,
  token: typeof window !== 'undefined' ? localStorage.getItem('token') || null : null,
  robot: null,

  setUser: (user) => set({ user }),
  setToken: (token) => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('token', token)
    }
    set({ token })
  },
  setRobot: (robot) => set({ robot }),
  logout: () => {
    if (typeof window !== 'undefined') {
      localStorage.removeItem('token')
    }
    set({ user: null, token: null, robot: null })
  }
}))
